module.exports = __webpack_public_path__ + "img/052-edit.23292043.svg";